module.exports = __webpack_public_path__ + "static/img/reporticon12.ea098e42.png";